import React from 'react';
import { ROUTES } from 'Navigation';
import { SubRoutesContainer } from 'Features/Shared';

export const ReportsMain: React.FC = () => {
  return <SubRoutesContainer route={ROUTES.REPORTS} />;
};
